export default __webpack_public_path__ + "static/media/6.5458500d.jpg";